<template>
  <div>
    <consulta-razon-social @go-to-list="goToList" key="hello" @clear-process-id="process = null" />
    <procesos-list v-if="!process" ref="list" @go-to-details="goToDetails" />
    <process-details
      :process="process"
      ref="details"
      v-if="process"
      @clear-process-id="process = null"
    />
  </div>
</template>
<script>
import ConsultaRazonSocial from "@/components/process/ConsultaRazonSocial";
import ProcesosList from "@/components/process/ProcesosList";
import ProcessDetails from "@/views/process/ProcessDetails";

export default {
  data() {
    return {
      process: null,
    };
  },
  components: {
    ConsultaRazonSocial,
    ProcesosList,
    ProcessDetails,
  },
  methods: {
    goToList() {
      this.processId = null;
      this.$vuetify.goTo(this.$refs.list);
    },
    goToDetails(process) {
      this.process = process;
    },
  },
  created() {
    this.$store.dispatch(
      "process/setUrlAyuda",
      "/manual/consulta.html#consulta-por-nombre-o-razon-social"
    );
  },
};
</script>
